export enum ModuleType {
  CCM = 'ccm',
  RPM = 'rpm',
  ADMIN = 'admin',
  RPMCCM = 'rpm-ccm',
  APCM = 'apcm',
}
